<template>
    <span class="caret-wrapper"
        v-bind:class="{'asc': name === current && status === 1,'desc': name === current && status === -1}"
    >
        <i class="sort-caret ascending"></i>
        <i class="sort-caret descending"></i>
    </span>
</template>
<script>
export default {
  name: 'sort-caret',
  props: {
    name: {
      type: String,
      default: "",
    },
    current: {
      type: String,
      default: "",
    },
    status: {
      type: Number,
      default: 0,
      description: '0: no sort, 1: asc, -1: desc'
    },
  }
};
</script>
<style>
.caret-wrapper {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 34px;
    width: 20px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;
    top: 9px;
    margin-top: -18px;
}
    
.caret-wrapper .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;
}
.caret-wrapper .sort-caret.ascending {
    border-bottom-color: #C0C4CC;
    top: 5px;
}
.caret-wrapper .sort-caret.descending {
    border-top-color: #C0C4CC;
    bottom: 7px;
}
.caret-wrapper.asc .sort-caret.ascending {
    border-bottom-color: #e14eca;
}
.caret-wrapper.desc .sort-caret.descending {
    border-top-color: #e14eca;
}
</style>
